import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
Vue.config.productionTip = false;
import JMDesign from "@jd/jm-design";
import "@jd/jm-design/lib/theme-default/index.css";
Vue.use(JMDesign);

import SelfToast from "./components/toast";
Vue.use(SelfToast);

// import vconsole from 'vconsole'
// var vConsole = new vconsole()
// Vue.use(vConsole)

import "@/utils/dateFormat";
import "lib-flexible";
import "@/assets/css/reset.css";
import "@/utils/mixin";
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");